/**
 * Gratis Shoppen (14.–16.08.) — shared runtime for the three gratis-shoppen-* snippets.
 *
 * Serves:
 *   snippets/gratis-shoppen-announcement-bar.liquid
 *   snippets/gratis-shoppen-display.liquid
 *   snippets/gratis-shoppen-cart-info.liquid
 *
 * WHY THIS LIVES IN assets/ AND NOT IN THE SNIPPETS
 * The cart drawer rebuilds itself with `currentInner.innerHTML = updatedInner.innerHTML`
 * (assets/theme.js, CartDrawer._onCartChanged). innerHTML parsing marks <script> elements
 * non-executable, so a <script> inside a cart-drawer snippet would run once on page load
 * and never again. <style> blocks and inline onclick= attributes DO survive, which is why
 * the markup calls the global below through an inline handler.
 *
 * The countdown re-queries the DOM on every tick and never holds a node reference, so a
 * drawer re-render is invisible to it — and because there is exactly one global interval,
 * repeated re-renders can never stack timers. Same architecture as
 * assets/jb-ferienstart-familienvorrat.js and assets/jb-mystery-geschenk-countdown.js.
 *
 * COUNTDOWN CONTRACT
 *   <div data-gs-countdown
 *        data-gs-targets="<iso>|<iso>|…"     first target still in the future wins
 *        data-gs-labels="<text>|<text>|…">   label shown for that target
 *     <span data-gs-label>…</span>
 *     <b data-gs-unit="h"></b> <b data-gs-unit="m"></b> <b data-gs-unit="s"></b>
 *   </div>
 *
 * Hours are TOTAL hours, not hours-within-a-day — there is no days box, and the
 * pre-start target (~35 h out) still reads correctly. Targets carry an explicit +02:00
 * offset so the countdown is right for a visitor in any timezone.
 *
 * When every target is in the past the root gets `is-ended` (CSS hides the component);
 * the class is removed again while time remains, so it recovers after a re-render.
 */
(function () {
  if (window.__gratisShoppenStarted) return;
  window.__gratisShoppenStarted = true;

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function setUnit(root, key, value) {
    var cell = root.querySelector('[data-gs-unit="' + key + '"]');
    if (cell && cell.textContent !== value) cell.textContent = value;
  }

  function tick() {
    var roots = document.querySelectorAll('[data-gs-countdown]');
    var now = Date.now();

    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var targets = (root.getAttribute('data-gs-targets') || '').split('|');
      var labels = (root.getAttribute('data-gs-labels') || '').split('|');

      // First target still ahead of us. Midnight rollover needs no special case:
      // the next tick simply selects the next entry in the list.
      var index = -1;
      var end = 0;
      for (var j = 0; j < targets.length; j++) {
        var parsed = new Date(targets[j]).getTime();
        if (!isNaN(parsed) && parsed > now) {
          index = j;
          end = parsed;
          break;
        }
      }

      if (index === -1) {
        setUnit(root, 'h', '00');
        setUnit(root, 'm', '00');
        setUnit(root, 's', '00');
        root.classList.add('is-ended');
        continue;
      }

      root.classList.remove('is-ended');

      var label = root.querySelector('[data-gs-label]');
      if (label && labels[index] && label.textContent !== labels[index]) {
        label.textContent = labels[index];
      }

      var remaining = Math.floor((end - now) / 1000);
      var h = Math.floor(remaining / 3600);
      remaining -= h * 3600;
      var m = Math.floor(remaining / 60);
      var s = remaining - m * 60;

      setUnit(root, 'h', pad(h));
      setUnit(root, 'm', pad(m));
      setUnit(root, 's', pad(s));
    }
  }

  /**
   * "En savoir plus" accordion on the product-page card. Exposed as a bare global and
   * wired through an inline onclick so it keeps working if the product info block is
   * re-rendered — same approach as toggleGoldenTicketAccordion in
   * snippets/golden-ticket-banner.liquid.
   */
  window.gratisShoppenToggle = function (button) {
    var card = button.closest('.gs-display');
    if (!card) return;

    var panel = card.querySelector('.gs-display__panel');
    if (!panel) return;

    var expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.classList.toggle('is-open', !expanded);
    panel.setAttribute('aria-hidden', expanded ? 'true' : 'false');

    var labelEl = button.querySelector('[data-gs-toggle-label]');
    if (labelEl) labelEl.textContent = expanded ? 'En savoir plus' : 'Afficher moins';
  };

  tick();
  setInterval(tick, 1000);
})();
